import React from 'react';
import { Link } from 'react-router-dom';

const WarnVerify = (props) => (
    <div className="alert-email">
        <span>Your email address is not yet verified. To re-send a verification code please visit your <Link to="/profile">edit profile</Link> page.</span>
    </div>
);


export default WarnVerify;


// WEBPACK FOOTER //
// ./src/App/WarnVerify.js